
class HXFormFieldTime extends HXFormField {

    constructor(inputName,formName) {
        super(inputName,formName);
    }

     /**
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        super._validateFieldInit();

         if (this.fieldExists()===true && this.getEditable() === true) {
            this.setValue(this.getValue()); //Inhalt pruefen und aufformatieren
            var value = ''+this.getValue();

            if (!this.getOptional() && value === '') {
                this.validationPassed = false;
                this.validationMsg = hx.replace(this.formVars.dictOptionalMsg, "#name#", this.getLabel());

            } else if (value!=='' && HXFormFieldUtils.getTimeTextFormated(value, this.getDisplaySeconds(), this.getIntervalMinute()) === null) {
                this.validationPassed = false;
                this.validationMsg = hx.replace(this.formVars.dictFormatMsg, "#name#", this.getLabel());
            }
            if (alertResult===true) super._validateFieldAlert();
        }
        return this.validationPassed;
    }

    /**
     * Setzt Text in Zeitfeld, wird autom. ins korrekte Format aufformatiert
     * @param {string} timeText z.B. '12:15''
     */
    setValue(timeText) {
        var formated = HXFormFieldUtils.getTimeTextFormated(timeText, this.getDisplaySeconds(), this.getIntervalMinute());
        if (formated!==null) timeText = formated;
        super.setValue(timeText);
    }

    /**
     * @param {boolean} optional
     */
    setOptional(optional) {
        super.setOptional(optional,'text');
    }

    /**
     * Liefert zurueck ob das Feld Sekunden anzeigt
     * @returns {boolean}
     */
    getDisplaySeconds() {
        return this.inputObj.getAttribute('data-hx-display-seconds') === 'true';
    }

    /**
     * Steuert ob das Feld Sekunden anzeigt
     * @param {boolean} displaySeconds
     */
    setDisplaySeconds(displaySeconds) {
        if (displaySeconds==true){
            this.inputObj.setAttribute('data-hx-display-seconds', 'true');
        }else{
            this.inputObj.setAttribute('data-hx-display-seconds', 'false');
        }
    }



    /**
     * Setzt das Minutenintervall
     * @param {float} minutes 0-60
     */
    setIntervalMinute(minutes) {
        this.inputObj.setAttribute('data-hx-minute-interval',hx.cfloat(minutes));
    }

    /**
     * Liefert das Minutenintervall zurueck
     * @returns {float}
     */
    getIntervalMinute() {
        return hx.cfloat(this.inputObj.getAttribute('data-hx-minute-interval'));
    }

    /**
     * Events einhaengen
     */
    displayInit() {
        if (this.fieldExists()===true && this.getEditable()) {
            this.inputObj.addEventListener("blur", (event) => {  //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
                this.setValue(this.getValue()); //Inhalt pruefen und aufformatieren
            });

            this.inputObj.addEventListener("keydown", (event) => {  // war auf keypress, aber nur mit keydown werden Arrow-Keys supported
                var result = HXFormFieldUtils.getTimeTextKeyEventResult(this.getValue(), event, this.getIntervalMinute(), this.getDisplaySeconds());
                if (result.timeText!==null) this.setValue(result.timeText);
                if (result.allowKey===false) event.preventDefault(); //Erscheinen ungueltiger Zeichen im Feld verhindern
                return result.allowKey;
            });
        }
    }
}